export default {
      id: "star-usage",
      viewBox: "0 0 60 61",
      url: __webpack_public_path__ + "img/icons.79e00d12.svg#star",
      toString: function () {
        return this.url;
      }
    }